<template>
  <div id="itf-form" class="tech-service-form-like">
    <validation-observer ref="itfValidation">
      <b-form autocomplete="off" class="form">
        <fa-icon
          v-b-tooltip.hover.top="'Ընդհատել'"
          class="closeAddForm"
          icon="times"
          @click="cancelForm"
        />

        <div class="extra_header">
          <h4 class="title">Տրանսպորտային միջոց</h4>
          <div class="borderDiv" />
        </div>

        <b-row>
          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <MazInput
                v-model="form.Owner"
                type="text"
                placeholder="ՏՄ տնօրինող"
                :dark="isDark"
                class="w-full mb-1 text-capitalize"
                :error="!!errors.length"
                old-left-icon-name="person"
              />
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <MazInput
                v-model="form.addressName"
                type="text"
                placeholder="ՏՄ Հաշվառման հասցե"
                :dark="isDark"
                class="w-full mb-1"
                readonly
                :error="!!errors.length"
                old-left-icon-name="location_on"
              />
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required|min:14">
              <MazInput
                v-model="form.Phone"
                v-mask="'(###) ##-##-##'"
                type="text"
                placeholder="Հեռախոսահամար"
                :dark="isDark"
                class="w-full mb-1"
                :error="!!errors.length"
                old-left-icon-name="phone"
              />
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <MazInput
                v-model="form.documentNumber"
                type="text"
                placeholder="Փաստաթղթի համարը"
                :dark="isDark"
                class="w-full mb-1 text-uppercase"
                :error="!!errors.length"
                old-left-icon-name="location_on"
              />
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <v-select
                v-model="form.car_id"
                :clearable="false"
                placeholder="Մակնիշը"
                :selectable="option => option.value !== null"
                :reduce="prefix => prefix.value"
                :class="!!errors.length ? 'is-invalid mb-1' : 'mb-1'"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="cars"
                @input="changeCarSelect"
              />
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <MazInput
                v-model="form.car_model"
                type="text"
                placeholder="Մոդել"
                :dark="isDark"
                class="w-full mb-1 text-uppercase"
                :error="!!errors.length"
              />
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <b-input-group class="mb-1">
                <b-input-group-prepend is-text>
                  <fa-icon icon="passport" />
                </b-input-group-prepend>
                <b-form-select
                  v-model="form.car_type_id"
                  :state="errors.length > 0 ? false : null"
                  @change="changeCarType"
                >
                  <option :value="null" disabled>Տիպ / Խումբ</option>
                  <template v-for="group in car_groups">
                    <optgroup :key="group.id" :label="group.name">
                      <option
                        v-for="type in car_types.filter(i => i.group === group.id)"
                        :key="type.id"
                        :value="type.id"
                      >
                        {{ type.name }}
                      </option>
                    </optgroup>
                  </template>
                </b-form-select>
              </b-input-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <MazInput
                v-model="form.CarRegNo"
                type="text"
                placeholder="Հաշվառման համարանիշը"
                :dark="isDark"
                class="w-full mb-1 text-uppercase"
                :error="!!errors.length"
                old-left-icon-name="timer_10"
              />
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <MazInput
                v-model="form.MadeAt"
                v-mask="'####'"
                type="text"
                placeholder="Թողարկման տարեթիվ"
                :dark="isDark"
                class="w-full mb-1"
                :error="!!errors.length"
                old-left-icon-name="calendar_today"
              />
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <MazInput
                v-model="form.VIN"
                type="text"
                placeholder="Նույնականացման VIN կոդ"
                :dark="isDark"
                class="w-full mb-1 text-uppercase"
                :error="!!errors.length"
                old-left-icon-name="code"
              />
            </validation-provider>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <v-select
                v-model="form.fuel_id"
                placeholder="Վառելիքի տեսակ"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="fuels"
                :reduce="prefix => prefix.value"
                :class="(!!errors.length) ? 'is-invalid mb-1' : 'mb-1'"
                :clearable="false"
                @input="changeFuel"
              />
            </validation-provider>
          </b-col>

          <b-col
            v-if="!isTrailerGroup"
            cols="12"
            md="4"
          >
            <MazInput
              v-model="form.EngineNo"
              type="text"
              placeholder="Շարժիչի համար"
              :dark="isDark"
              class="w-full mb-1"
            />
          </b-col>

          <b-col
            v-if="!isTrailerGroup"
            cols="12"
            md="4"
          >
            <MazInput
              v-model="form.engine_type"
              type="text"
              placeholder="Շարժիչի տեսակ"
              :dark="isDark"
              class="w-full mb-1"
            />
          </b-col>

          <b-col cols="12" md="4">
            <MazInput
              type="text"
              placeholder="Արատորոշման քարտ"
              :dark="isDark"
              class="w-full mb-1"
              readonly
              :success="form.classificators.length > 0"
              old-left-icon-name="checklist"
              @click="openClassificators"
            >
              <fa-icon
                slot="icon-right"
                icon="plus-square"
                class="rightIcon faRightIcon"
                @click="openClassificators"
              />
            </MazInput>
          </b-col>

          <b-col cols="12" md="4">
            <validation-provider #default="{ errors }" rules="required">
              <MazSelect
                v-model="form.NextCheckup"
                placeholder="Հաջորդ ՏԶ"
                :dark="isDark"
                class="w-full mb-1"
                :error="!!errors.length"
                :options="next_tech_services"
                old-left-icon-name="next_plan"
              />
            </validation-provider>
          </b-col>

          <b-col v-if="company && company.camera" cols="12" md="4" class="d-flex align-items-start">
            <div v-if="form.camera" class="camera-preview mr-1">
              <img :src="attachmentUrl" alt="camera" />
            </div>
          </b-col>
        </b-row>

        <b-row class="mt-1">
          <b-col cols="12" class="d-flex justify-content-end">
            <b-button
              variant="primary"
              class="itf-save-btn"
              :disabled="saving"
              @click="save"
            >
              Պահպանել
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>

    <b-modal
      id="modal-itf-classificators"
      modal-class="itf-classificators-modal"
      content-class="itf-classificators-modal-content"
      body-class="itf-classificators-modal-body"
      :no-close-on-backdrop="true"
      ok-title="Հաստատել"
      cancel-title="Մերժել"
      centered
      size="lg"
      title="Արատորոշումներ"
      :is-valid="false"
    >
      <div class="itf-classificators-list">
        <b-form-checkbox
          v-for="classificator in classificatorsTree"
          :key="classificator.id"
          v-model="form.classificators"
          :value="classificator.id"
          :class="[
            'custom-control-primary classificator-checkbox',
            { 'is-child': classificator.isChild },
          ]"
        >
          {{ classificator.name }}<sup v-if="classificator.note">{{ classificator.note }}</sup>
        </b-form-checkbox>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormSelect,
  BInputGroup,
  BInputGroupPrepend,
  BModal,
  BRow,
  VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { computed } from '@vue/composition-api'
import useAppConfig from '@core/app-config/useAppConfig'
import store from '@/store'
import itfModule from '@/store/itf/itf'
import carsModule from '@/store/cars/cars'

export default {
  name: 'ItfForm',
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BButton,
    BCol,
    BForm,
    BFormCheckbox,
    BFormGroup,
    BFormSelect,
    BInputGroup,
    BInputGroupPrepend,
    BModal,
    BRow,
    vSelect,
    ValidationObserver,
    ValidationProvider,
  },
  setup() {
    const { skin } = useAppConfig()
    const isDark = computed(() => skin.value === 'dark')
    return { skin, isDark }
  },
  data() {
    return {
      ITF_STORE_MODULE_NAME: 'itfModule',
      CARS_STORE_MODULE_NAME: 'carsModule',
      saving: false,
      form: {
        Owner: '',
        addressName: '',
        region: '',
        county: '',
        street: '',
        address: '',
        Phone: '',
        documentNumber: '',
        car: '',
        car_id: null,
        car_model: '',
        car_group: '',
        car_group_id: null,
        car_type: '',
        car_type_id: null,
        CarRegNo: '',
        MadeAt: '',
        VIN: '',
        fuel: '',
        fuel_id: null,
        fuel_name: '',
        EngineNo: '',
        engine_type: '',
        engine_power: null,
        NextCheckup: null,
        classificators: [],
        vehicle_type: '',
        weight: '',
        max_weight: '',
        mobile: '',
        psn: '',
        reg_num: '',
        camera: null,
        video: null,
        autoDetection: false,
        cameraReason: null,
        cameraReasonId: null,
      },
    }
  },
  computed: {
    company() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].company
        || (this.$store.state.techServiceModule && this.$store.state.techServiceModule.company)
        || null
    },
    copy() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].copy
    },
    copy_form() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].copy_form
    },
    edit() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].edit
    },
    edit_form() {
      return this.$store.state[this.ITF_STORE_MODULE_NAME].form
    },
    userType() {
      try {
        return atob(this.$store.state.user_type)
      } catch (e) {
        return null
      }
    },
    isAdmin() {
      return this.userType === 'ADMIN'
    },
    isTrailerGroup() {
      return (this.form.car_group || '') === 'Կցորդներ'
    },
    classificators() {
      return (this.$store.state[this.ITF_STORE_MODULE_NAME].classificators || [])
        .filter(c => c.status !== false)
        .filter(c => !(this.isTrailerGroup && c.hideForTrailers))
    },
    classificatorsTree() {
      const active = this.classificators
      const byParent = {}
      active.forEach(c => {
        const key = c.parent ? String(c.parent) : 'root'
        if (!byParent[key]) byParent[key] = []
        byParent[key].push(c)
      })

      Object.keys(byParent).forEach(key => {
        byParent[key].sort((a, b) => (a.ordering || 0) - (b.ordering || 0))
      })

      const roots = byParent.root || []
      const result = []
      roots.forEach(root => {
        result.push({ ...root, isChild: false })
        const children = byParent[String(root.id)] || []
        children.forEach(child => {
          result.push({ ...child, isChild: true })
        })
      })
      return result
    },
    car_groups() {
      return this.$store.state[this.CARS_STORE_MODULE_NAME].car_groups || []
    },
    car_types() {
      return this.$store.state[this.CARS_STORE_MODULE_NAME].car_types || []
    },
    cars() {
      let primaryFinished = false
      const cars = []
      const data = this.$store.state[this.CARS_STORE_MODULE_NAME].cars || []
      for (const car of data) {
        if (!car.primary && !primaryFinished) {
          primaryFinished = true
          cars.push({
            label: '-----------------------------------',
            value: null,
            disabled: true,
          })
        }
        cars.push({
          label: car.name,
          value: car.id,
        })
      }
      return cars
    },
    fuels() {
      return (this.$store.state[this.CARS_STORE_MODULE_NAME].fuels || []).map(e => ({
        label: e.name,
        value: e.id,
      }))
    },
    next_tech_services() {
      return [
        { value: '0', label: '6 ամսից' },
        { value: 1, label: '1 տարուց' },
        { value: 2, label: '2 տարուց' },
      ]
    },
    attachmentUrl() {
      if (!this.form.camera) return null
      return `${process.env.VUE_APP_API_URL}/${this.form.camera}`
    },
  },
  async created() {
    if (!store.hasModule(this.ITF_STORE_MODULE_NAME)) {
      store.registerModule(this.ITF_STORE_MODULE_NAME, itfModule)
    }
    if (!store.hasModule(this.CARS_STORE_MODULE_NAME)) {
      store.registerModule(this.CARS_STORE_MODULE_NAME, carsModule)
    }

    await Promise.all([
      this.$store.dispatch(`${this.ITF_STORE_MODULE_NAME}/getClassificators`),
      this.$store.dispatch(`${this.CARS_STORE_MODULE_NAME}/getFuels`),
      this.$store.dispatch(`${this.CARS_STORE_MODULE_NAME}/getCars`),
      this.$store.dispatch(`${this.CARS_STORE_MODULE_NAME}/getGroups`),
      this.$store.dispatch(`${this.CARS_STORE_MODULE_NAME}/getTypes`),
      this.$store.dispatch(`${this.ITF_STORE_MODULE_NAME}/getCompany`).catch(() => {}),
    ])

    if (this.edit) {
      this.fillFromEdit()
    } else if (this.copy) {
      this.fillFromCopy()
    }
  },
  methods: {
    mapClassificatorIds(list) {
      if (!Array.isArray(list)) return []
      return list.map(c => {
        if (typeof c === 'object') return c.id || c._id
        return c
      }).filter(Boolean)
    },
    fillFromData(data, options = {}) {
      const owner = data.Owner
        || (data.ownerStatus && data.ownerStatus.Owner)
        || ''
      const engineTypeName = (data.engine_type_id && data.engine_type_id.name)
        || data.engine_type
        || ''

      this.form = {
        ...this.form,
        _id: data._id || data.id || null,
        id: data.id || data._id || null,
        Owner: owner,
        region: data.region || '',
        county: data.county || '',
        street: data.street || '',
        address: data.address || '',
        addressName: [data.region, data.county, data.street, data.address].filter(Boolean).join(', '),
        Phone: options.clearPhone ? '' : (data.Phone || ''),
        documentNumber: data.documentNumber || '',
        car: data.car || '',
        car_id: typeof data.car_id === 'object' && data.car_id
          ? (data.car_id.id || data.car_id._id)
          : (data.car_id || null),
        car_model: data.car_model || '',
        car_group: data.car_group || '',
        car_group_id: typeof data.car_group_id === 'object' && data.car_group_id
          ? (data.car_group_id.id || data.car_group_id._id)
          : (data.car_group_id || null),
        car_type: data.car_type || '',
        car_type_id: typeof data.car_type_id === 'object' && data.car_type_id
          ? (data.car_type_id.id || data.car_type_id._id)
          : (data.car_type_id || null),
        CarRegNo: data.CarRegNo || '',
        MadeAt: data.MadeAt || '',
        VIN: data.VIN || '',
        fuel: data.fuel || '',
        fuel_id: typeof data.fuel_id === 'object' && data.fuel_id
          ? (data.fuel_id.id || data.fuel_id._id)
          : (data.fuel_id || null),
        fuel_name: data.fuel_name || '',
        EngineNo: data.EngineNo || data.engine_num || '',
        engine_type: engineTypeName,
        engine_power: data.engine_power ?? null,
        NextCheckup: options.resetNextCheckup
          ? null
          : (data.NextCheckup === 0 ? '0' : data.NextCheckup),
        classificators: options.resetClassificators
          ? []
          : this.mapClassificatorIds(data.classificators),
        vehicle_type: data.vehicle_type || '',
        weight: data.weight != null ? String(data.weight) : '',
        max_weight: data.max_weight != null ? String(data.max_weight) : '',
        mobile: data.mobile || '',
        psn: data.psn || '',
        reg_num: data.reg_num || '',
        camera: data.camera || null,
        video: data.video || null,
        autoDetection: data.autoDetection || false,
        cameraReason: data.cameraReason || null,
        cameraReasonId: data.cameraReasonId || null,
      }

      if (!this.form.car_id && this.form.car) {
        const foundCar = (this.$store.state[this.CARS_STORE_MODULE_NAME].cars || [])
          .find(c => (c.name || '').toLowerCase() === String(this.form.car).toLowerCase())
        if (foundCar) {
          this.form.car_id = foundCar.id
        }
      }

      if (!this.form.car_type_id && this.form.car_type) {
        const foundType = this.car_types.find(t => t.name === this.form.car_type)
        if (foundType) {
          this.form.car_type_id = foundType.id
          this.changeCarType(foundType.id)
        }
      } else if (this.form.car_type_id) {
        this.changeCarType(this.form.car_type_id)
      }

      if (!this.form.fuel_id && (data.fuel_name || data.fuel)) {
        const found = this.fuels.find(f => f.label === data.fuel_name || f.label === data.fuel)
        if (found) {
          this.form.fuel_id = found.value
          this.form.fuel = found.label
        }
      }
    },
    fillFromCopy() {
      this.fillFromData(this.copy_form || {}, {
        clearPhone: true,
        resetNextCheckup: true,
        resetClassificators: true,
      })
      this.$nextTick(() => this.applyTrailerGroupRules())
    },
    fillFromEdit() {
      this.fillFromData(this.edit_form || {})
      this.$nextTick(() => this.applyTrailerGroupRules())
    },
    changeCarSelect(event) {
      const carId = (event && event.value) ? event.value : event
      if (!carId) return
      const cars = this.$store.state[this.CARS_STORE_MODULE_NAME].cars || []
      const index = cars.findIndex(e => e.id === carId)
      if (index >= 0) {
        this.form.car_id = cars[index].id
        this.form.car = cars[index].name
      }
    },
    changeCarType(id) {
      const index = this.car_types.findIndex(e => e.id === id)
      if (index >= 0) {
        this.form.car_type_id = this.car_types[index].id
        this.form.car_type = this.car_types[index].name
        const groupIndex = this.car_groups.findIndex(g => g.id === this.car_types[index].group)
        if (groupIndex >= 0) {
          this.form.car_group_id = this.car_groups[groupIndex].id
          this.form.car_group = this.car_groups[groupIndex].name
        }
        this.applyTrailerGroupRules()
      }
    },
    applyTrailerGroupRules() {
      if (!this.isTrailerGroup) return

      this.form.EngineNo = ''
      this.form.engine_type = ''

      const allowed = new Set(this.classificators.map(c => String(c.id)))
      this.form.classificators = (this.form.classificators || [])
        .map(id => String(id))
        .filter(id => allowed.has(id))
    },
    changeFuel(event) {
      const fuelId = (event && event.value) ? event.value : event
      const fuel = this.fuels.find(f => f.value === fuelId)
      this.form.fuel_id = fuelId
      this.form.fuel = fuel ? fuel.label : ''
    },
    openClassificators() {
      this.applyTrailerGroupRules()
      this.$bvModal.show('modal-itf-classificators')
    },
    cancelForm() {
      if (this.edit) {
        this.$store.commit(`${this.ITF_STORE_MODULE_NAME}/CLOSE_EDIT_FORM`)
      } else {
        this.$store.commit(`${this.ITF_STORE_MODULE_NAME}/CHANGE_ADD_STATE`, false)
      }
      this.$emit('cancel')
    },
    save() {
      this.$refs.itfValidation.validate().then(success => {
        if (!success) return

        const vin = (this.form.VIN || '').trim()
        if (!vin) {
          this.$swal({
            icon: 'error',
            text: 'VIN կոդը պարտադիր է',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
          })
          return
        }

        if (this.company && this.company.camera && !this.form.camera && !this.form.cameraReasonId) {
          this.$swal({
            icon: 'error',
            text: 'Լուսանկարը պարտադիր է',
            customClass: { confirmButton: 'btn btn-primary' },
            buttonsStyling: false,
          })
          return
        }

        this.saving = true
        this.$vs.loading()
        this.applyTrailerGroupRules()
        const payload = {
          ...this.form,
          documentNumber: (this.form.documentNumber || '').toUpperCase(),
          CarRegNo: (this.form.CarRegNo || '').toUpperCase(),
          VIN: vin.toUpperCase(),
          NextCheckup: this.form.NextCheckup === '0' ? 0 : this.form.NextCheckup,
        }
        delete payload.addressName

        const action = this.edit
          ? (this.isAdmin ? 'editAdminItf' : 'editItf')
          : 'addItf'

        this.$store.dispatch(`${this.ITF_STORE_MODULE_NAME}/${action}`, payload)
          .then(() => {
            this.$vs.loading.close()
            this.saving = false
            if (this.edit) {
              this.$store.commit(`${this.ITF_STORE_MODULE_NAME}/CLOSE_EDIT_FORM`)
            } else {
              this.$store.commit(`${this.ITF_STORE_MODULE_NAME}/CHANGE_ADD_STATE`, false)
              this.$store.commit(`${this.ITF_STORE_MODULE_NAME}/OPEN_DOC`, 'print')
            }
            this.$emit('saved')
          })
          .catch(error => {
            this.$vs.loading.close()
            this.saving = false
            this.$root.$emit('getError', error)
          })
      })
    },
  },
}
</script>

<style lang="scss">
#itf-form {
  position: relative;
  padding: 1rem;

  .extra_header {
    display: flex;
    align-items: center;
    margin: 1rem 0;

    .title {
      margin: 0 1rem 0 0;
      white-space: nowrap;
    }

    .borderDiv {
      flex: 1;
      border-top: 1px solid #ddd;
    }
  }

  .closeAddForm {
    position: absolute;
    right: 1.5rem;
    top: 1rem;
    cursor: pointer;
    font-size: 1.4rem;
    z-index: 2;
  }

  .camera-preview {
    width: 56px;
    height: 46px;
    overflow: hidden;
    border-radius: 4px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .v-select {
    margin-bottom: 0.5rem;
  }

  .rightIcon.faRightIcon {
    cursor: pointer;
  }

  .itf-save-btn {
    min-width: 220px;
    padding: 1rem 2rem;
  }
}
</style>

<style lang="scss">
.itf-classificators-modal {
  .modal-dialog {
    max-width: 600px;
  }
}

.itf-classificators-modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.itf-classificators-list {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.itf-classificators-list .classificator-checkbox {
  display: flex !important;
  align-items: flex-start;
  margin: 0 !important;
  width: 100%;

  &.is-child {
    margin-left: 1.5rem !important;
    width: calc(100% - 1.5rem);
  }

  .custom-control-label {
    line-height: 1.35;
    padding-top: 0.1rem;
  }

  sup {
    font-size: 0.7em;
  }
}
</style>
